/**
 * A country's flag, from its ISO 3166-1 alpha-2 code.
 *
 * Regional indicator symbols: `A` (U+0041) maps to U+1F1E6, so a two-letter
 * code is two code points and there is no table to keep up to date — a country
 * added by a future provider gets its flag for free.
 *
 * **Decorative, always beside the code.** It is `aria-hidden`, because the code
 * is what carries the meaning and "flag of Poland, PL" is noise; and where a
 * platform cannot render the pair (Windows shows the bare letters) the label is
 * already there, so nothing is lost.
 */
export function flagOf(code: string): string {
  if (!/^[A-Za-z]{2}$/.test(code)) return ""
  return [...code.toUpperCase()]
    .map((letter) => String.fromCodePoint(0x1f1e6 + letter.charCodeAt(0) - 0x41))
    .join("")
}

export function Flag({ code }: { code: string }) {
  const flag = flagOf(code)
  if (flag === "") return null
  return (
    <span aria-hidden="true" className="not-italic">
      {flag}
    </span>
  )
}
